import { FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';

export function getErrors(formGroup: FormGroup): ValidationErrors {

  let result = formGroup.errors || {};

  if (formGroup.valid) return null;

  Object.keys(formGroup.controls).forEach(key => {

    const ctrl = formGroup.get(key);

    if (ctrl instanceof FormGroup) {
      const subErrors = getErrors(ctrl);
      result = {...result, ...subErrors };
    } else if (!ctrl.valid) {
      result[key] = ctrl.errors;
    }

  });

  return result;
}

/*
  Loops through each child component for the given FormGroup executing callback (cb).
 */
export function forEachChild(formGroup: FormGroup, cb: (v: any, k: string) => void): void {
  Object.keys(formGroup.controls).forEach(k => {
    const control = formGroup.controls[k];
    cb(control, k);
    if (control instanceof FormGroup) {
      forEachChild(control, cb);
    }
  });
}

export function scrollToError(
  document: Document,
  fieldSelector: string = 'mat-form-field,.ap-button-toggle-group,.ap-form-field',
  errorSelector: string = '.mat-error,.ap-error-message'): boolean {

  const formFields = document.querySelectorAll(fieldSelector);
  let foundError = false;
  formFields.forEach(element => {
    if (!foundError && element.querySelector(errorSelector) != null) {
      foundError = true;
      element.scrollIntoView({ behavior: 'smooth' });
    }
  });

  return foundError;
}

export function isModelNullOrEmpty(model: any): boolean {
  if (model == null) {
    return true;
  }

  for (const [key, value] of Object.entries(model)) {
    if (value != null) {
      return false;
    }
  }
  return true;
}